















































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import { HOST } from "../global";

import {
  VueFlux,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
} from "vue-flux";
@Component({
  name: "SlideBlock",
  components: {
    VueFlux,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader
  },
})
export default class SlideBlock extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;

  data() {
    return {
      vfOptions: {
        autoplay: true,
        delay: 4000,
        fullscreen: true,
        gestures: true,
        responsive: true,
      },
      vfTransitions: ["round2"],
    };
  }

  fluxOptions: any = {
    autoplay: true,
    fullscreen: true,
  };
  // fluxTransitions: any = {
  //     transitionSlide: Transitions.transitionBlocks2
  // };
  get deviceType(): string {
    const width = document.body.offsetWidth;
    if (width <= 425) {
      return "mobile";
    } else if (width <= 1024) {
      return "tab";
    } else {
      return "original";
    }
  }

  get slideImages(): string[] {
    if (this.compData != null) {
      return this.compData.slider.map((slide: any, idx: number) => {
        return `${HOST}${slide[this.deviceType].src}`;
      });
    } else {
      return [];
    }
  }

}
